import styles from "@entities/Onboarding/ui/styles.module.scss";
import { errorMessages } from "@features/Onboarding/lib/constants";
import { useSignInValidation } from "@features/Onboarding/lib/hooks/useSignInValidation";
import { AuthStep } from "@pages/Onboarding/Onboarding";
import { Button, Flex, Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetMe } from "../lib/hooks/useGetMe";

interface SignInFormValues {
  email: string;
  password: string;
}

interface LoginFormProps {
  navigateTo: (step: AuthStep) => void;
}

export const LoginForm: React.FC<LoginFormProps> = ({ navigateTo }) => {
  const { handleLogin, loading } = useSignInValidation();
  const { isFetching, refetchUserDetails } = useGetMe();
  const [form] = Form.useForm<SignInFormValues>();
  const [errors, setErrors] = useState<Partial<SignInFormValues>>({});
  const navigate = useNavigate();

  const onFinish = async (values: SignInFormValues) => {
    try {
      await handleLogin(values);
      const res = await refetchUserDetails();
      if (res?.data?.data?.isMfaRequired) {
        navigateTo("TWO_FACTOR");
      } else if (!res?.error) {
        navigate("/");
      }
      // navigateTo("TWO_FACTOR");
    } catch (error) {
      setErrors(error as Partial<SignInFormValues>);
    }
  };

  const [searchParams] = useSearchParams();

  const initalemailId = searchParams.get("emailId");

  useEffect(() => {
    if (initalemailId) {
      form.setFieldsValue({ email: initalemailId });
    }
  }, [initalemailId, form]);

  return (
    <div>
      <h2 className={styles.title}>Sign in to your account</h2>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        size="large"
        initialValues={{ email: "", password: "" }}
        requiredMark={false}
      >
        <Form.Item
          label="Email"
          name="email"
          className={styles.formItem}
          rules={[
            { required: true, message: errorMessages.email },
            { pattern: /\S+@\S+\.\S+/, message: errorMessages.email },
          ]}
          validateStatus={errors.email ? "error" : ""}
          help={errors.email}
        >
          <Input placeholder="name@company.com" disabled={loading} />
        </Form.Item>
        <Form.Item
          label={
            <Flex justify="space-between" style={{ width: "100%" }}>
              <span>Password</span>
              <a
                onClick={() => navigateTo("FORGOT_PASSWORD")}
                className={styles.forgotLink}
              >
                Forgot your password?
              </a>
            </Flex>
          }
          name="password"
          className={styles.formItem}
          rules={[
            { required: true, message: errorMessages.password },
            { min: 6, message: errorMessages.password },
          ]}
          validateStatus={errors.password ? "error" : ""}
          help={errors.password}
        >
          <Input.Password
            placeholder="Enter your password"
            disabled={loading}
          />
        </Form.Item>
        {/* <div className={styles.formFooter}>
          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox>Remember me on this device</Checkbox>
          </Form.Item>
        </div> */}
        <Button
          type="primary"
          htmlType="submit"
          block
          loading={loading || isFetching}
          size="large"
        >
          Sign in
        </Button>
      </Form>
    </div>
  );
};
